import * as React from "react";
import { useContext } from "react";
import Confirm from "components/dialog/confirm";
import TextField from "components/form/text-field";
import SelectField from "components/form/select-field";
import MenuItem from "material-ui/MenuItem";
import { Form } from "formsy-react";
import { $, merge } from "glamor";
import Checkbox from "material-ui/Checkbox";
import Label from "components/form/label";
import ChevronIcon from "material-ui/svg-icons/navigation/chevron-left";
import IconButton from "material-ui/IconButton";
import { BrandDropdown } from "components/product-collection/product-collection-header-components/brand-dropdown";
import theme from "styles/theme";
import classNames from "classnames";
import { ICopyProps } from "actions/collections/collection";
import { format, formatMessage } from "lib/globalize-util";
import fetch from "lib/fetch";
import config from "site-config";
import { get, cloneDeep } from "lodash";
import {
    AllocationDimensionKind,
    AllocationDimensionOwnerObject,
    IAllocationDimension,
} from "helpers/allocation-dimension";
import Grid from "@material-ui/core/Grid";
import { ValuesSelect } from "components/product-collections/start-assortment-modal/values-select";
import {
    isThereAtLeastOneDimensionValueChecker,
    handleOnAllocationDimensionValuesChangeFactory,
} from "components/product-collections/start-assortment-modal/start-assortment-modal";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import FolderOutlinedIcon from "@material-ui/icons/FolderOutlined";
import ButtonBase from "@material-ui/core/ButtonBase";
import {
    AssortmentFolderSelection,
    useInitializeAssortmentFolderSelection,
} from "containers/folders/containers/space-manager/components/folder-selection/assortment-folder-selection";
import Slide from "@material-ui/core/Slide";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useFolderSelection } from "containers/folders/containers/space-manager/components/folder-selection/use-folder-selection";
import { isConfirmSelectionDisabled } from "containers/folders/containers/space-manager/components/folder-selection/folder-selection";
import { IFolderSelection } from "containers/folders/containers/space-manager/components/folder-selection/folder-navigation";
import { AlertNotification } from "components/alert/alert-notification";
import { SeverityMessages } from "constants/product-collection";
import { SpaceView } from "containers/folders/hooks/utils";
import { DATATEST } from "constants/integration";
import { PurchaseOrderFields } from "helpers/delivery-purchase-order";
import { fetchBrandsData, IFetchBrandsDataPayload } from "actions/brands-data-actions";
import { IBrandsDataStatePayload } from "reducers/brands-data-reducers";
import { CollectionType } from "containers/folders/types/assortment";
import { useFetchAssortmentMerchants } from "containers/management/merchant-inventory-settings/hooks/merchant";
import { useFlags } from "launchdarkly-react-client-sdk";
import { IStore } from "reducers";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { getAllocationDimensions } from "reducers/selectors/collection";
import { parseAssortmentId } from "helpers/product-collection";
import { mapBrandEntitiesToDataById } from "containers/product-collections/product-collection-page";
import {
    getMerchantAllocationDimensionListIsRequesting,
    getMerchantDefaultGenericAllocationDimensions,
} from "reducers/selectors/merchant";
import { getMerchantPreferenceRequest } from "actions/merchant";
import { listAllocationDimensionRequest } from "actions/allocation-dimension";
import * as actions from "actions/collections";
import { nameExtRemover } from "containers/folders/utils/space-item";
import { ItemKind } from "containers/folders/types/base";
import { ProductCollectionContext } from "../product-collection/product-collection-context";
import { hasVerticalAssortmentAccess } from "containers/folders/utils/vertical-assortments";
import { IBrand } from "containers/folders/types/brands";
import me from "models/me";
import { navigateTo } from "containers/folders/utils/navigator";
import {
    getDefaultAssortmentType,
    getDefaultSelectedBrandId,
    validateMerchantBrandMatch,
} from "../../helpers/copy-assortments-helpers";
import { isMyDriveEnabled } from "containers/folders/utils/permissions";

const styles = merge(
    $(".copyContainer", {
        minHeight: 353,
    }),
    $(" .typeAndBrandContainer", {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    }),
    $(" .typeContainer", {
        marginTop: "5px",
    }),
    $(" .retailerContainer", {
        marginTop: 15,
        marginBottom: 10,
        "& .muiDropdown": {
            width: "200px !important",
        },
    }),
    $(" .label", {
        fontWeight: "bold !important",
    }),
    $(" .noBrandWarning", {
        fontSize: "12px",
        color: theme.palette.warning,
        opacity: "0",
    }),
    $(" .show", {
        opacity: "1",
    }),
    $(" .disabledBrand", {
        cursor: "not-allowed !important",
    }),
    $(" .disabledBrandContainer", {
        opacity: "0.5",
    }),
    $(" .optionsCheck", {
        margin: "10px",
    }),
    $(" .allocationDimensionsContainer", {
        display: "flex",
        justifyContent: "space-between",
    }),
    $(" .chooseDestinationContainer", {
        paddingBottom: 24,
        marginBottom: 24,
        borderBottom: `1px solid ${theme.palette.borderColor}`,
    }),
    $(" .chooseDestination", {
        border: `1px solid ${theme.palette.borderColor}`,
        borderRadius: 4,
        width: "100%",
        height: 40,
        display: "flex",

        "& svg": {
            height: 18,
            width: 18,
            margin: "0 12px 0 16px",
        },

        "& span": {
            flex: 1,
            textAlign: "left",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "100%",
        },
    }),
    $(" .noIcon", {
        marginLeft: 16,
    })
);
const muiStyles = {
    brandSelector: {
        border: `1px solid ${theme.palette.borderColor}`,
        width: "220px",
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
        padding: "0 10px",
        position: "relative" as "relative",
        height: "40px",
        cursor: "pointer",
    },
    selectedBrand: {
        overflow: "hidden",
        maxWidth: "180px",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap" as "nowrap",
    },
    label: {
        marginTop: "16px",
        fontWeight: "bold !important",
    },
    chevronIcon: {
        transform: "rotate(-90deg)",
        color: `${theme.palette.borderColor}`,
    },
    iconButton: {
        position: "absolute" as "absolute",
        right: "0px",
    },
    popover: {
        maxWidth: "400px",
        padding: "12px",
        overflowY: "auto",
    },
    titleContent: {
        display: "flex",
        alignItems: "center",
    },
    backButton: {
        padding: 4,
        height: 32,
    },
    textField: {
        width: "192px",
    },
};

const WITH_ITEMS = "withItems";
const WITH_PERMISSIONS = "withPermissions";
const WITH_DOOR_LABELS = "withDoorLabels";
const WITH_PO_DETAILS = "withPODetails";
const WITH_TARGET_DATA = "targetData";
const ALLOCATION_DATA = "allocationData";
const PLAN_DATA = "planData";
const DEFAULT_ROW = "defaultRow";
const PATH_TO_ALLOCATION_DIMENTION_SUBTYPE = "mutable_mixed.objects.field_map.map.fields.subtype.string_value";

interface OwnProps {
    onConfirm?: (params: ICopyProps) => void;
    onConfirmClose: () => void;
    onSuccess: () => void;
    isCopyConfirmationOpen: boolean;
    assortmentName?: string;
    canShopBrand?: boolean;
    onFetchBrandsData?: (query: IFetchBrandsDataPayload["query"]) => void;
    isFetchingBrandsData?: boolean;
    isSaveAs?: boolean;
    onCopyCallback?: (params: actions.ICopyProps) => void;
    poiId?: string;
    brand?: IBrand;
}

interface ReduxProps {
    canEditPlan: boolean;
    collectionId: string;
    brandsDataById: IBrandsDataStatePayload["brandsDataById"];
    collectionBrandId?: string;
    collectionDriveItem?: nuorder.folder.v1.Item;
    allocationDimensions: IAllocationDimension[];
    genericMerchantAllocationDimensions: IAllocationDimension[];
    requestingMerchantAllocationDimensions: boolean;
    collectionMerchantId: string;
    userMerchantId: string;
    targetMerchantId?: string;
    collectionPoiId?: string;
    myBrand?: IBrand;
}

interface ReduxDispatchProps {
    fetchMerchantPreference: (merchantId: string) => void;
    fetchMerchantAllocationDimensions: (merchantId: string) => void;
    onCopyAssortment?: (params: actions.ICopyProps) => void;
    reduxIsFetchingBrandsData?: boolean;
    reduxOnFetchBrandsData?: (query: IFetchBrandsDataPayload["query"]) => void;
}

interface ICollectionSnapshot {
    [props: string]: any;
}

export const CopyAssortmentConfirmModal: React.FunctionComponent<OwnProps & ReduxProps & ReduxDispatchProps> = ({
    canEditPlan,
    isCopyConfirmationOpen,
    onConfirm,
    onCopyAssortment,
    onCopyCallback,
    onConfirmClose,
    assortmentName,
    collectionBrandId,
    brandsDataById,
    collectionId,
    collectionDriveItem,
    onSuccess,
    allocationDimensions: collectionAllocationDimensions = [],
    genericMerchantAllocationDimensions,
    requestingMerchantAllocationDimensions,
    fetchMerchantPreference,
    fetchMerchantAllocationDimensions,
    collectionMerchantId,
    userMerchantId,
    canShopBrand,
    reduxIsFetchingBrandsData,
    reduxOnFetchBrandsData,
    isFetchingBrandsData,
    onFetchBrandsData,
    isSaveAs = false,
    targetMerchantId = "",
    collectionPoiId,
    brand,
    myBrand,
}) => {
    const {
        allocationBagVersion1,
        assortmentSettings,
        verticalAssortmentsEnabled,
        financialTarget: isTargetFeatureEnabled,
    } = useFlags();
    const brandScope = brand ?? myBrand;
    const isVerticalAssortmentEnabled = React.useMemo(() => {
        return hasVerticalAssortmentAccess(
            me,
            validateMerchantBrandMatch(collectionMerchantId, brandScope),
            verticalAssortmentsEnabled
        );
    }, [brandScope, verticalAssortmentsEnabled, collectionMerchantId]);

    const defaultCopyName = format("Copy of |assortmentName|", {
        assortmentName:
            assortmentName !== undefined
                ? assortmentName
                : nameExtRemover(collectionDriveItem?.name ?? "assortment", ItemKind.CollectionDocument),
    });
    const isCloseoutBrandAssortment =
        collectionDriveItem?.collection_facet?.collection_type === CollectionType.BrandStandard;

    const defaultAssortmentType = getDefaultAssortmentType({
        isVerticalAssortmentEnabled,
        isCloseoutBrandAssortment,
        hasBrandPortalId: !!collectionDriveItem?.collection_facet?.brand_portal_id,
    });

    const productCollectionContext = useContext(ProductCollectionContext);

    const defaultSelectedBrandId = getDefaultSelectedBrandId({
        canShopBrand,
        collectionDriveItem,
        isVerticalAssortmentEnabled,
        canShopBrandOnProductCollectionContext: productCollectionContext.canShopBrand,
    });

    const displayMyDrive = React.useMemo(
        () => isMyDriveEnabled(brandScope, verticalAssortmentsEnabled),
        [brandScope, verticalAssortmentsEnabled]
    );

    const mergedIsFetchingBrandsData =
        isFetchingBrandsData !== undefined ? isFetchingBrandsData : reduxIsFetchingBrandsData;

    const [copyName, setCopyName] = React.useState<string>(defaultCopyName);
    const [currentAssortmentType, setCurrentAssortmentType] = React.useState<string>(defaultAssortmentType);
    const [brandPopoverOpen, setBrandPopoverOpen] = React.useState<boolean>(false);
    const [selectedBrandId, setSelectedBrandId] = React.useState<string>(defaultSelectedBrandId);
    const [withPermissions, setWithPermissions] = React.useState<boolean>(true);
    const [withDefaultRow, setWithDefaultRow] = React.useState<boolean>(true);
    const [withItems, setWithItems] = React.useState<boolean>(true);
    const [withDoorLabels, setWithDoorLabels] = React.useState<boolean>(true);
    const [allocationData, setAllocationData] = React.useState<boolean>(false);
    const [withPODetails, setwithPODetails] = React.useState<boolean>(true);
    const [withTargetData, setWithTargetData] = React.useState<boolean>(!!isTargetFeatureEnabled);
    const [planData, setPlanData] = React.useState<boolean>(false);
    const [allocationDimensionId, setAllocationDimensionId] = React.useState<string>(undefined);
    const [currentBagVersion, setCurrentBagVersion] = React.useState<string>(undefined);
    const [memberMerchantId, setMemberMerchantId] = React.useState<string>(null);
    const [deliveryPurchaseOrders, setDeliveryPurchaseOrders] = React.useState<PurchaseOrderFields[]>([]);
    const [folderDestination, setFolderDestination] = React.useState<IFolderSelection>(null);
    const [isOpenFolderSelection, setOpenFolderSelection] = React.useState<boolean>(false);
    const [copyAssortmentError, setCopyAssortmentError] = React.useState<string>(null);
    const [settings, setSettings] = useFolderSelection();
    const [allocationDimensions, setAllocationDimensions] = React.useState<IAllocationDimension[]>([]);
    const _anchorRef = React.useRef<HTMLDivElement>(null);
    const _isMounted = React.useRef<boolean>(false);
    const internalToExternal =
        defaultAssortmentType === CollectionType.Internal && currentAssortmentType === CollectionType.External;
    const externalChangeBrand =
        currentAssortmentType === CollectionType.External && defaultSelectedBrandId !== selectedBrandId;
    const [excludedAllocationDimensionValues, setExcludedAllocationDimensionValues] = React.useState<{
        [allocationDimensionId: string]: string[];
    }>({});
    const [allocationDimensionValues, setAllocationDimensionValues] = React.useState<{
        [allocationDimensionId: string]: string[];
    }>({});
    const [isCopying, setIsCopying] = React.useState<boolean>(false);
    const [selectedTargetMerchantId, setSelectedTargetMerchantId] = React.useState<string>(targetMerchantId);

    const hasAllocationDimensions = collectionAllocationDimensions.length > 0;
    const brandIds = React.useMemo(() => Object.keys(brandsDataById), [brandsDataById]);
    const { data: merchants } = useFetchAssortmentMerchants({ enabled: isCloseoutBrandAssortment });

    const merchantOptions = React.useMemo(
        () =>
            merchants?.map((merchant) => ({
                id: merchant.value,
                text: merchant.label,
            })) || [],
        [merchants]
    );

    React.useEffect(() => {
        _isMounted.current = true;

        // If there is allocation dimensions, cross-check with merchant preference if allocation dimension values are still active.
        if (hasAllocationDimensions) {
            fetchMerchantPreference(collectionMerchantId);
            fetchMerchantAllocationDimensions(collectionMerchantId);
        } else {
            fetchCollectionSnapshot();
        }
        return () => {
            _isMounted.current = false;
            _anchorRef.current = null;
        };
    }, [hasAllocationDimensions, collectionMerchantId]); // eslint-disable-line react-hooks/exhaustive-deps

    const fetchCollectionSnapshot = () => {
        fetch(`${config.goAPI}/v1/collections/${collectionId}?with_snapshot=true&merchant_id=${userMerchantId}`, {
            method: "GET",
            noDomain: true,
        })
            .then((res) => {
                if (!res.ok) {
                    throw res;
                }
                return res.json();
            })
            .then((result) => {
                if (_isMounted.current) {
                    const allocationDimensionId = findAllocationDimensionId(result);
                    setAllocationDimensionId(allocationDimensionId);
                    const allocationDimensionsData = result.collection.snapshot?.allocation_dimensions || {};
                    const deliveryPurchaseOrders =
                        result.collection.snapshot?.delivery_purchase_orders?.mutable_list?.values ?? [];
                    setDeliveryPurchaseOrders(deliveryPurchaseOrders);
                    const allocationDimensionList = generateAllocationDimensionsData(allocationDimensionsData);
                    setAllocationDimensions(allocationDimensionList);
                    setExcludedAllocationDimensionValues(
                        allocationDimensionList.reduce(
                            (acc, curr) => ({
                                ...acc,
                                [curr.id]: curr.dimension_values
                                    .filter((v) => v.active && !v.included)
                                    .map((v) => v.id),
                            }),
                            {}
                        )
                    );
                    const allocationDimensionValuesObj = generateAllocationDimensionsValueData(allocationDimensionList);
                    setAllocationDimensionValues(allocationDimensionValuesObj);

                    setMemberMerchantId(result.collection.merchant_v1_id);

                    setCurrentBagVersion(result.collection.bag_version);
                }
            })
            .catch((_error) => {
                // do nothing.
            });
    };

    React.useEffect(() => {
        if (
            !requestingMerchantAllocationDimensions &&
            hasAllocationDimensions &&
            genericMerchantAllocationDimensions.length > 0
        ) {
            fetchCollectionSnapshot();
        }
    }, [requestingMerchantAllocationDimensions]); // eslint-disable-line react-hooks/exhaustive-deps

    const generateAllocationDimensionsValueData = (allocationDimensionList) => {
        const totalAllocationDimensionValues = allocationDimensionList.reduce((acc, item) => {
            acc[item.id] = item.dimension_values.filter((value) => value.active).map((value) => value.id);
            return acc;
        }, {});
        return totalAllocationDimensionValues;
    };

    const generateAllocationDimensionsData = (existingAllocationDimensionsData) => {
        const list = genericMerchantAllocationDimensions
            .map((genericMerchantAllocationDimension) => {
                const existingDimension = existingAllocationDimensionsData[genericMerchantAllocationDimension.id];

                if (genericMerchantAllocationDimension.subtype !== AllocationDimensionKind.Generic) {
                    return;
                }

                const existingDimensionValues =
                    existingDimension?.mutable_mixed?.objects?.dimension_values?.list?.values ?? [];

                const copiedAllocationDimension = cloneDeep(genericMerchantAllocationDimension);
                // Ensure merchant dimension value's `included` flag matches existing value
                copiedAllocationDimension.dimension_values.forEach((dimensionValue) => {
                    const existingDimensionValue = existingDimensionValues.find(
                        (value) => value.struct_value.id === dimensionValue.id
                    );
                    dimensionValue.included = existingDimensionValue
                        ? existingDimensionValue.struct_value.included
                        : false;
                });
                return copiedAllocationDimension;
            })
            .filter((item) => item !== undefined);
        return list;
    };

    const findAllocationDimensionId = (allocationDimensionObj: ICollectionSnapshot) => {
        let allocationDimensionId = undefined;
        const { collection } = allocationDimensionObj;
        const { snapshot, item_allocation_dimension_order } = collection;
        const allocationDimensions = snapshot?.allocation_dimensions;
        if (item_allocation_dimension_order && allocationDimensions) {
            // NOTE: find the LAST subtype "GENERIC" return object_id.
            const itemAllocationDimensionReverseOrder = item_allocation_dimension_order.slice().reverse();
            for (const dimensionName of itemAllocationDimensionReverseOrder) {
                const allocationDimension = allocationDimensions[dimensionName];
                if (
                    get(allocationDimension, PATH_TO_ALLOCATION_DIMENTION_SUBTYPE) === AllocationDimensionKind.Generic
                ) {
                    allocationDimensionId = allocationDimension.ref.object_id;
                    setAllocationData(true);
                    // Note: only when is Owner or Manager, set planData to true.
                    setPlanData(canEditPlan);
                    break;
                }
            }
        }
        return allocationDimensionId;
    };

    const handleConfirm = () => {
        let params;
        const bagVersion = allocationBagVersion1 || currentBagVersion === "1" ? 1 : 0;

        if (isSaveAs) {
            params = {
                name: copyName,
                type: CollectionType.External,
                brandId: collectionBrandId,
                inventory_enabled: true,
                collectionId,
                excludedAllocationDimensionValues,
                allocationDimensionValues,
                parentId: folderDestination?.id,
                merchantId: userMerchantId,
                bagVersion,
                collectionPoiId,
            };
        } else if (isCloseoutBrandAssortment) {
            params = {
                name: copyName,
                brandId: selectedBrandId,
                withItems,
                withPermissions,
                withDefaultRow,
                collectionType: currentAssortmentType,
                collectionId,
                withDoorLabels: false,
                allocationData: false,
                withPODetails: false,
                withTargetData: false,
                planData: false,
                excludedAllocationDimensionValues,
                allocationDimensionValues,
                parentId: folderDestination?.id,
                merchantId: userMerchantId,
                targetMerchantId: selectedTargetMerchantId,
                bagVersion,
                collectionPoiId,
            };
        } else {
            params = {
                name: copyName,
                brandId: selectedBrandId,
                withItems,
                withPermissions,
                withDefaultRow,
                collectionType: currentAssortmentType,
                collectionId,
                withDoorLabels,
                allocationData,
                withPODetails,
                withTargetData,
                planData,
                excludedAllocationDimensionValues,
                allocationDimensionValues,
                parentId: folderDestination?.id,
                merchantId: userMerchantId,
                bagVersion,
                collectionPoiId,
            };
        }

        params.callback = (assortmentId, error) => {
            setIsCopying(false);

            if (!error) {
                onSuccess && onSuccess();

                const isNewFlag =
                    assortmentSettings && currentAssortmentType === CollectionType.External ? "?isNew=true" : "";
                navigateTo({
                    route: `/assortment/${assortmentId}${isNewFlag}`,
                    newTab: true,
                    title: formatMessage("Assortment Copied"),
                    message: formatMessage("Do you want to go to the assortment?"),
                });
            } else {
                setCopyAssortmentError(error);
            }
        };

        setIsCopying(true);
        setCopyAssortmentError(null);

        if (onConfirm) {
            onConfirm(params);
        } else {
            onCopyAssortment(params);
            onCopyCallback(params);
        }
    };
    const updateBrands = React.useCallback(
        (brandMap) => {
            // fetch all brands only when collections only have 2 brands or less
            if (Object.keys(brandMap).length <= 2) {
                // Call fast `onFetchBrandsData` to quickly fetch brands to show in brand-picker
                if (onFetchBrandsData) {
                    onFetchBrandsData({ assortment_brands_only: true });
                } else {
                    reduxOnFetchBrandsData({ assortment_brands_only: true });
                }
            }
        },
        [onFetchBrandsData, reduxOnFetchBrandsData]
    );
    const handleBrandPopover = React.useCallback(() => {
        setBrandPopoverOpen(true);
        updateBrands(brandsDataById);
    }, [brandsDataById, updateBrands]);
    const handleCloseBrandPopover = () => {
        setBrandPopoverOpen(false);
    };
    const handleSelectBrand = (brandId: string) => {
        setSelectedBrandId(brandId);
        setBrandPopoverOpen(false);
        if (brandId !== defaultSelectedBrandId && defaultAssortmentType === CollectionType.External) {
            setWithItems(false);
            setAllocationData(false);
        }
    };
    const handleConfirmClose = React.useCallback(
        (_e) => {
            onConfirmClose();
        },
        [onConfirmClose]
    );

    const handleNameChange = React.useCallback((_event: Event, value: string) => setCopyName(value), []);

    const handleTypeChange = (_event, _i, status) => {
        setCurrentAssortmentType(status);
        // internal to exteranl
        if (defaultAssortmentType === CollectionType.Internal && status === CollectionType.External) {
            setWithItems(false);
            setAllocationData(false);
        }
        // external to internal
        if (status === CollectionType.Internal) {
            setSelectedBrandId(undefined);
        }
        if (status === CollectionType.External && selectedBrandId === undefined) {
            setSelectedBrandId(defaultSelectedBrandId);
        }
    };

    const handleChangeMerchant = React.useCallback(
        (_event, _i, value) => {
            setSelectedTargetMerchantId(value);
        },
        [setSelectedTargetMerchantId]
    );

    const handleOptionschange = (e, status) => {
        const value = e.target.value;
        switch (value) {
            case WITH_ITEMS:
                if (internalToExternal || externalChangeBrand) {
                    setWithItems(false);
                    setAllocationData(false);
                } else {
                    setWithItems(status);
                    !status && setAllocationData(false);
                }
                break;
            case WITH_PERMISSIONS:
                setWithPermissions(status);
                break;
            case WITH_DOOR_LABELS:
                setWithDoorLabels(status);
                break;
            case ALLOCATION_DATA:
                setAllocationData(status);
                break;
            case PLAN_DATA:
                setPlanData(canEditPlan && status);
                break;
            case WITH_PO_DETAILS:
                setwithPODetails(status);
                break;
            case WITH_TARGET_DATA:
                setWithTargetData(status);
                break;
            case DEFAULT_ROW:
                setWithDefaultRow(status);
                break;
            default:
                break;
        }
    };
    const brandNameForSingleBrandAssortment = selectedBrandId && brandsDataById[selectedBrandId]?.name;
    const displayBrandName =
        isFetchingBrandsData && selectedBrandId
            ? formatMessage("Fetching brands...")
            : selectedBrandId
              ? brandsDataById[selectedBrandId]?.name
              : formatMessage("Select Brand");
    // NOTE: externalAssortment must have brand.
    const exernalWithoutBrandId =
        currentAssortmentType === CollectionType.External &&
        !brandNameForSingleBrandAssortment &&
        !isFetchingBrandsData;
    const dimensionValuesExist = React.useCallback(() => {
        return isThereAtLeastOneDimensionValueChecker(excludedAllocationDimensionValues, allocationDimensions);
    }, [excludedAllocationDimensionValues, allocationDimensions]);

    const isSelectionDisabled = React.useMemo(
        () => isConfirmSelectionDisabled(settings, collectionDriveItem, false, true),
        [settings, collectionDriveItem]
    );
    const isConfirmDisabled = React.useMemo(() => {
        if (isOpenFolderSelection) {
            return isSelectionDisabled;
        }

        return !folderDestination || folderDestination.spaceView === SpaceView.SharedWithMe;
    }, [isOpenFolderSelection, folderDestination, isSelectionDisabled]);

    const getFolderDestination = React.useCallback(
        (_settings) => {
            if (isSelectionDisabled) {
                return null;
            }

            const { itemSelected, navigation } = _settings;
            return itemSelected || navigation[navigation.length - 1];
        },
        [isSelectionDisabled]
    );

    const handleBackToForm = React.useCallback(() => {
        setOpenFolderSelection(false);
        const selection = getFolderDestination(settings);
        // if selection is not defined it mean is a not allowed selection, so we need to keep the previous selection
        selection && setFolderDestination(selection);
    }, [setOpenFolderSelection, getFolderDestination, settings, setSettings]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleOpenChooseDestination = React.useCallback(() => {
        setOpenFolderSelection(true);
    }, [setOpenFolderSelection]);

    const handleClearCopyAssortmentError = React.useCallback(() => {
        setCopyAssortmentError(null);
    }, [setCopyAssortmentError]);

    const { displayMerchantDrive, membership, mySpace, merchantSpace, parentItem, isFetchingLineage } =
        useInitializeAssortmentFolderSelection(
            userMerchantId,
            collectionDriveItem,
            (lineage: IFolderSelection[], view: SpaceView) => {
                setSettings({
                    navigation: lineage,
                    currentItemId: lineage[lineage.length - 1].id,
                    currentView: view,
                    rootItemId: lineage[0].id,
                });
            }
        );
    React.useEffect(() => {
        if (!folderDestination && parentItem) {
            setFolderDestination(parentItem as IFolderSelection);
        }
    }, [parentItem, folderDestination, setFolderDestination]);

    const mainTitle = isSaveAs ? formatMessage("Save As") : formatMessage("Copy Assortment");

    return (
        <>
            <Confirm
                disabledConfirm={
                    (!isOpenFolderSelection && !dimensionValuesExist()) ||
                    exernalWithoutBrandId ||
                    isConfirmDisabled ||
                    isCopying ||
                    isFetchingLineage ||
                    requestingMerchantAllocationDimensions ||
                    (selectedBrandId !== null && selectedBrandId !== undefined && isFetchingBrandsData)
                }
                contentStyle={{ maxWidth: "500px" }}
                title={
                    <div style={muiStyles.titleContent}>
                        {isOpenFolderSelection && (
                            <IconButton onClick={handleBackToForm} style={muiStyles.backButton}>
                                <ArrowBackIcon fontSize="large" />
                            </IconButton>
                        )}
                        <span>{!isOpenFolderSelection ? mainTitle : formatMessage("Choose destination")}</span>
                    </div>
                }
                open={isCopyConfirmationOpen}
                onConfirm={isOpenFolderSelection ? handleBackToForm : handleConfirm}
                onCancel={handleConfirmClose}
                confirmLabel={isOpenFolderSelection ? formatMessage("Select") : ""}
                cancelLabel={formatMessage("Cancel")}
                hideCancelButton={isOpenFolderSelection}
            >
                <div className="copyContainer" {...styles}>
                    <Slide
                        direction="right"
                        in={!isOpenFolderSelection}
                        timeout={250}
                        style={{ display: !isOpenFolderSelection ? "block" : "none" }}
                    >
                        <Form>
                            <AlertNotification
                                message={copyAssortmentError}
                                open={!!copyAssortmentError}
                                onClose={handleClearCopyAssortmentError}
                                severity={SeverityMessages.Error}
                                dataTest={DATATEST.ASSORTMENTS.COPY_ASSORTMENT_ERROR}
                                noMargin
                            />
                            <div className="chooseDestinationContainer">
                                <Label className="label" style={muiStyles.label}>
                                    {formatMessage("Choose destination")}
                                </Label>
                                <ButtonBase
                                    className="chooseDestination"
                                    onClick={handleOpenChooseDestination}
                                    data-test={DATATEST.ASSORTMENTS.CHOOSE_ASSORTMENT_DESTINATION_BTN}
                                    disabled={isFetchingLineage}
                                >
                                    {!!folderDestination && <FolderOutlinedIcon />}
                                    <span
                                        className={classNames({ noIcon: !folderDestination })}
                                        data-test={DATATEST.ASSORTMENTS.CHOOSE_ASSORTMENT_DESTINATION_TEXT}
                                    >
                                        {folderDestination?.name || formatMessage("Please select")}
                                    </span>
                                    <ChevronRightIcon />
                                </ButtonBase>
                            </div>
                            <div className="assortmentNameContainer">
                                <TextField
                                    labelClassName="label"
                                    label={formatMessage("Name")}
                                    name="copyAssortmentName"
                                    defaultValue={copyName}
                                    fullWidth={true}
                                    onChange={handleNameChange}
                                    large={false}
                                    dataTest={DATATEST.ASSORTMENTS.COPY_ASSORTMENT_INPUT}
                                />
                            </div>
                            {!isSaveAs && (
                                <>
                                    {!isVerticalAssortmentEnabled && !isCloseoutBrandAssortment && (
                                        <div className="typeAndBrandContainer">
                                            <div className="typeContainer">
                                                <SelectField
                                                    label={
                                                        <span className="label">
                                                            {formatMessage("Assortment Type")}
                                                        </span>
                                                    }
                                                    value={currentAssortmentType}
                                                    onChange={handleTypeChange}
                                                    name="assortmentType"
                                                    style={muiStyles.textField}
                                                    data-test={DATATEST.ASSORTMENTS.COPY_ASSORTMENT_SELECT_TYPE}
                                                >
                                                    <MenuItem
                                                        value={CollectionType.Internal}
                                                        primaryText={formatMessage("Multi Brand")}
                                                    />
                                                    <MenuItem
                                                        value={CollectionType.External}
                                                        primaryText={formatMessage("Single Brand")}
                                                    />
                                                </SelectField>
                                            </div>
                                            <div
                                                className={classNames("brandContainer", {
                                                    disabledBrandContainer:
                                                        currentAssortmentType === CollectionType.Internal,
                                                })}
                                            >
                                                <Label className="label" style={muiStyles.label}>
                                                    {formatMessage("Brand")}
                                                </Label>
                                                <div
                                                    className={classNames({
                                                        disabledBrand:
                                                            currentAssortmentType === CollectionType.Internal,
                                                    })}
                                                    style={muiStyles.brandSelector}
                                                    onClick={handleBrandPopover}
                                                    data-test={DATATEST.ASSORTMENTS.COPY_ASSORTMENT_BRAND_DROPDOWN}
                                                >
                                                    <span style={muiStyles.selectedBrand}>{displayBrandName}</span>
                                                    <IconButton
                                                        disabled={currentAssortmentType === CollectionType.Internal}
                                                        iconStyle={muiStyles.chevronIcon}
                                                        style={muiStyles.iconButton}
                                                    >
                                                        <ChevronIcon />
                                                    </IconButton>
                                                </div>
                                                {currentAssortmentType === CollectionType.External && (
                                                    <BrandDropdown
                                                        ids={brandIds}
                                                        entities={brandsDataById}
                                                        anchorEl={_anchorRef}
                                                        open={brandPopoverOpen}
                                                        onRequestClose={handleCloseBrandPopover}
                                                        onBrandChange={handleSelectBrand}
                                                        selectedBrandId={selectedBrandId}
                                                        popOverStyle={muiStyles.popover}
                                                        assortmentOnly={true}
                                                        isFetchingBrands={mergedIsFetchingBrandsData}
                                                    />
                                                )}
                                                <div ref={_anchorRef} />
                                                <div
                                                    className={classNames("noBrandWarning", {
                                                        show: exernalWithoutBrandId,
                                                    })}
                                                >
                                                    {formatMessage("External assortment needs a brand.")}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {isCloseoutBrandAssortment && (
                                        <div className="retailerContainer">
                                            <SelectField
                                                label={<span className="label">{formatMessage("Retailer")}</span>}
                                                data-test={DATATEST.ASSORTMENTS.COPY_ASSORTMENT_MERCHANT_DROPDOWN}
                                                value={selectedTargetMerchantId}
                                                onChange={handleChangeMerchant}
                                                name="retailer"
                                                width="200"
                                            >
                                                {merchantOptions.map(({ text, id }) => (
                                                    <MenuItem
                                                        data-test={DATATEST.DYNAMIC_FIELDS.LIST_ITEM}
                                                        key={id}
                                                        value={id}
                                                        primaryText={text}
                                                    />
                                                ))}
                                            </SelectField>
                                        </div>
                                    )}
                                    <div className="optionsContainer">
                                        <Checkbox
                                            disabled={
                                                (internalToExternal || externalChangeBrand) &&
                                                !isCloseoutBrandAssortment
                                            }
                                            className="optionsCheck"
                                            checked={withItems}
                                            value={WITH_ITEMS}
                                            onCheck={handleOptionschange}
                                            label={formatMessage("Include items & notes")}
                                            data-test={DATATEST.ASSORTMENTS.COPY_ASSORTMENT_INCLUDE_NOTE_CBX}
                                        />
                                        <Checkbox
                                            className="optionsCheck"
                                            checked={withPermissions}
                                            value={WITH_PERMISSIONS}
                                            onCheck={handleOptionschange}
                                            label={formatMessage("Share with the same people")}
                                            data-test={DATATEST.ASSORTMENTS.COPY_ASSORTMENT_SHARE_WITH_SAME_PEOPLE_CBX}
                                        />
                                        {allocationDimensionId && (
                                            <Checkbox
                                                className="optionsCheck"
                                                checked={withDoorLabels}
                                                value={WITH_DOOR_LABELS}
                                                onCheck={handleOptionschange}
                                                label={formatMessage("Include door attributes")}
                                                data-test={DATATEST.ASSORTMENTS.COPY_ASSORTMENT_INCLUDE_DOOR_LABELS}
                                            />
                                        )}

                                        {deliveryPurchaseOrders.length > 0 && (
                                            <Checkbox
                                                className="optionsCheck"
                                                checked={withPODetails}
                                                value={WITH_PO_DETAILS}
                                                onCheck={handleOptionschange}
                                                label={formatMessage("Include PO details")}
                                                data-test={DATATEST.ASSORTMENTS.COPY_ASSORTMENT_INCLUDE_PO_DETAILS}
                                            />
                                        )}

                                        {allocationDimensionId && (
                                            <Checkbox
                                                disabled={!withItems}
                                                className="optionsCheck"
                                                checked={allocationData}
                                                value={ALLOCATION_DATA}
                                                onCheck={handleOptionschange}
                                                label={formatMessage("Include allocation data")}
                                                data-test={DATATEST.ASSORTMENTS.COPY_ASSORTMENT_INCLUDE_ALLOCATION}
                                            />
                                        )}
                                        {allocationDimensionId && (
                                            <Checkbox
                                                disabled={!canEditPlan}
                                                className="optionsCheck"
                                                checked={planData}
                                                value={PLAN_DATA}
                                                onCheck={handleOptionschange}
                                                label={formatMessage("Include plan data")}
                                                data-test={DATATEST.ASSORTMENTS.COPY_ASSORTMENT_INCLUDE_PLAN}
                                            />
                                        )}
                                        <Checkbox
                                            disabled={!canEditPlan}
                                            className="optionsCheck"
                                            checked={withDefaultRow}
                                            value={DEFAULT_ROW}
                                            onCheck={handleOptionschange}
                                            label={formatMessage("Include default row values")}
                                            data-test={DATATEST.ASSORTMENTS.COPY_ASSORTMENT_SHARE_WITH_DEFAULT_ROW_CBX}
                                        />
                                        {isTargetFeatureEnabled && (
                                            <Checkbox
                                                className="optionsCheck"
                                                checked={withTargetData}
                                                value={WITH_TARGET_DATA}
                                                onCheck={handleOptionschange}
                                                label={formatMessage("Include plan targets")}
                                                data-test={DATATEST.ASSORTMENTS.COPY_ASSORTMENT_INCLUDE_TARGET}
                                            />
                                        )}
                                    </div>
                                </>
                            )}

                            <div className="allocationDimensionsContainer">
                                {allocationDimensions.map((allocationDimension) => (
                                    <React.Fragment key={allocationDimension.id}>
                                        <Grid item={true}>
                                            <ValuesSelect
                                                merchantAllocationDimension={allocationDimension}
                                                onChange={handleOnAllocationDimensionValuesChangeFactory(
                                                    allocationDimension,
                                                    setExcludedAllocationDimensionValues
                                                )}
                                            />
                                        </Grid>
                                    </React.Fragment>
                                ))}
                            </div>
                        </Form>
                    </Slide>
                    <Slide
                        direction="left"
                        in={isOpenFolderSelection}
                        timeout={250}
                        mountOnEnter
                        unmountOnExit
                        style={{ display: isOpenFolderSelection ? "block" : "none" }}
                    >
                        <div>
                            <AssortmentFolderSelection
                                settings={settings}
                                onUpdateSettings={setSettings}
                                displayMerchantDrive={displayMerchantDrive}
                                displayMyDrive={displayMyDrive}
                                membership={membership}
                                mySpace={mySpace}
                                merchantSpace={merchantSpace}
                                item={collectionDriveItem}
                            />
                        </div>
                    </Slide>
                </div>
            </Confirm>
        </>
    );
};

const mapStateToProps = (store: IStore, ownProps) => {
    const { validAssortmentIds } = store.collection || {};

    const { isRollupMode, baseAssortmentId: _baseAssortmentId } = parseAssortmentId(ownProps.params?.id);
    const baseAssortmentId =
        isRollupMode && validAssortmentIds?.length && validAssortmentIds[0] !== _baseAssortmentId
            ? validAssortmentIds[0]
            : _baseAssortmentId;

    const { poiId } = ownProps;

    const allocationDimensions = getAllocationDimensions(store, baseAssortmentId, poiId);
    const collection = store.mutate.snapshots && store.mutate.snapshots.get(baseAssortmentId);

    const brandId = ownProps.params?.brand;
    const myBrand = store?.entities?.brands?.[brandId];

    return {
        collectionId: baseAssortmentId,
        canEditPlan: store.collection?.driveItem?.capabilities.can_edit_plan,
        brandsDataById:
            store.brandsData.payload?.brandsDataById || mapBrandEntitiesToDataById(store.entities.brands) || {},
        allocationDimensions,
        collectionBrandId: collection?.getIn(["brand_collection_properties", "struct_value", "brand_id"]),
        collectionDriveItem: store.collection?.driveItem,
        reduxIsFetchingBrandsData: store.brandsData.isFetching,
        genericMerchantAllocationDimensions: getMerchantDefaultGenericAllocationDimensions(store),
        requestingMerchantAllocationDimensions: getMerchantAllocationDimensionListIsRequesting(store),
        collectionMerchantId: collection?.getIn(["merchant_v1_id", "string_value"], ""),
        userMerchantId: store.collection.merchantId,
        targetMerchantId: collection?.getIn(["brand_collection_properties", "struct_value", "target_merchant_id"]),
        collectionPoiId: poiId,
        myBrand,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchMerchantPreference: (merchantId: string) => dispatch(getMerchantPreferenceRequest(merchantId)),
        fetchMerchantAllocationDimensions: (merchantId: string) =>
            dispatch(listAllocationDimensionRequest(merchantId, AllocationDimensionOwnerObject.Merchant)),
        reduxOnFetchBrandsData: (query) => dispatch(fetchBrandsData({ query })),
        onCopyAssortment: ({
            brandId,
            collectionId,
            collectionType,
            name,
            withItems,
            withPermissions,
            withDefaultRow,
            withDoorLabels,
            withPODetails,
            withTargetData,
            allocationData,
            planData,
            excludedAllocationDimensionValues,
            allocationDimensionValues,
            parentId,
            merchantId,
            callback,
            targetMerchantId,
            bagVersion,
            collectionAllocationDimensions,
            collectionPoiId,
        }) =>
            dispatch(
                actions.copyCollection({
                    brandId,
                    collectionId,
                    collectionType,
                    name,
                    withItems,
                    withPermissions,
                    withDefaultRow,
                    withDoorLabels,
                    withPODetails,
                    withTargetData,
                    allocationData,
                    planData,
                    excludedAllocationDimensionValues,
                    allocationDimensionValues,
                    parentId,
                    merchantId,
                    callback,
                    targetMerchantId,
                    bagVersion,
                    collectionAllocationDimensions,
                    collectionPoiId,
                })
            ),
    };
};

export const CopyAssortmentConfirmModalWithRedux = withRouter(
    connect<ReduxProps, ReduxDispatchProps, OwnProps>(mapStateToProps, mapDispatchToProps)(CopyAssortmentConfirmModal)
);
